import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageLogin = lazy(() => import("./layout/index"));

export const routerPageLogin: RouterItemType = {
  path: "/login",
  authorize: false,
  localization: false,
  element: <LayoutPageLogin />,
};
